module.exports = __webpack_public_path__ + "img/pic_life_2.01890966.jpg";